'use client';

import { useCallback, useEffect, useState } from 'react';
import useTranslations from '@/hooks/useTranslations';
import { v4 } from 'uuid';
import ErrorDetail from '@/components/ErrorDetail';

// App's -> Error Page
export default function Error({
  reset,
  error
}: {
  reset: () => void;
  error: Error & { digest?: string };
}): JSX.Element {
  const [instanceId, setInstanceId] = useState<string | undefined>(undefined);
  const translations = useTranslations();
  const handleReset = useCallback(() => {
    reset();
  }, [reset]);

  useEffect(() => {
    const errorId = v4();
    setInstanceId(errorId);

    const logError = async () => {
      const payload = {
        instanceId: errorId,
        error
      };
      try {
        await fetch('/venues/api/log', {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: {
            'Content-Type': 'application/json'
          }
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to log error');
      }
    };

    logError();
  }, [error]);

  return <ErrorDetail reset={handleReset} translations={translations} instanceId={instanceId} />;
}
